
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeakerOn as ObiSpeakerOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speaker-on.js';
 
 
 

 
 export const ObiSpeakerOn = createComponent({
   react: React,
   tagName: 'obi-speaker-on',
   elementClass: ObiSpeakerOnElement,
   events: {
     
   }
  });
 
 